import { Workbook, DataBind } from '../../workbook/index';
import { WorkbookSave, WorkbookNumberFormat, WorkbookFormula, WorkbookOpen, WorkbookSort, WorkbookFilter } from '../integrations/index';
import { WorkbookEdit, WorkbookCellFormat, WorkbookHyperlink, WorkbookInsert, WorkbookDelete } from '../actions/index';
import { WorkbookFindAndReplace, WorkbookProtectSheet, WorkbookDataValidation, WorkbookMerge } from '../actions/index';
/**
 * Workbook all module.
 * @private
 */
var WorkbookAllModule = /** @class */ (function () {
    /**
     * Constructor for Workbook all module.
     * @private
     */
    function WorkbookAllModule() {
        Workbook.Inject(DataBind, WorkbookSave, WorkbookNumberFormat, WorkbookCellFormat, WorkbookEdit, WorkbookFormula, WorkbookOpen, WorkbookSort, WorkbookHyperlink, WorkbookFilter, WorkbookInsert, WorkbookDelete, WorkbookFindAndReplace, WorkbookProtectSheet, WorkbookDataValidation, WorkbookMerge);
    }
    /**
     * For internal use only - Get the module name.
     * @private
     */
    WorkbookAllModule.prototype.getModuleName = function () {
        return 'workbook-all';
    };
    /**
     * Destroys the Workbook all module.
     * @return {void}
     */
    WorkbookAllModule.prototype.destroy = function () {
        /* code snippet */
    };
    return WorkbookAllModule;
}());
export { WorkbookAllModule };
